import type { DependencyPlan } from '@cli-types/next-adapter/init.js'
import { CLI_PACKAGE_NAME } from '@cli-constants/cli.js'
import { getCurrentCliVersion } from '@cli-utils/paths.js'
import { matchesVersionSpec } from '@cli-utils/version.js'
import { isLocalPackageSpec } from '@next-adapter/package-json/is-local-package-spec.js'
import { readProjectPackageJson } from '@next-adapter/package-json/read-project-package-json.js'
import { getDeclaredCliDependency } from './get-declared-cli-dependency.js'

export function getCliDependencySyncPlan(cwd: string): DependencyPlan | null {
  const currentVersion = getCurrentCliVersion()
  if (!currentVersion || currentVersion === '0.0.0') {
    return null
  }

  const desiredDependency = `${CLI_PACKAGE_NAME}@${currentVersion}`
  const pkg = readProjectPackageJson(cwd)
  if (!pkg) {
    return {
      dependencies: [],
      devDependencies: [desiredDependency]
    }
  }

  const declaredDependency = getDeclaredCliDependency(pkg)
  if (!declaredDependency) {
    return {
      dependencies: [],
      devDependencies: [desiredDependency]
    }
  }

  if (
    isLocalPackageSpec(declaredDependency.spec) ||
    matchesVersionSpec(declaredDependency.spec, currentVersion)
  ) {
    return null
  }

  return declaredDependency.section === 'dependencies'
    ? {
        dependencies: [desiredDependency],
        devDependencies: []
      }
    : {
        dependencies: [],
        devDependencies: [desiredDependency]
      }
}
